import React from 'react'
import { routeParseAbsolute } from '@app/lib/router-handler'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { Link } from '@app/components/stateless/typo/link'
import { Paragraph } from '../stateless/typo/paragraph'
import { Header2 } from '../general/header'
import Trans from 'next-translate/Trans'

// rendr auth frequired link
export const AuthRequired = () => {
  const { t, lang } = useTranslation()

  return (
    <div className='space-y-2'>
      <Trans
        i18nKey='errors:auth-error'
        components={[<Header2 key={'head-1'} />]}
      />
      <Trans
        i18nKey='errors:paid-auth'
        components={[
          <Paragraph key={'h-2'} />,
          <Link
            href={routeParseAbsolute('/login', lang)}
            className={'text-blue-600 hover:text-blue-400'}
            key={'h-3'}
          >
            {t('common:login')}
          </Link>,
        ]}
      />

      <div className='py-2'>
        <Link
          href={routeParseAbsolute('/login', lang)}
          className={
            'text-blue-600 hover:text-blue-400 border-2 px-4 py-2 rounded'
          }
        >
          {t('common:login')}
        </Link>
      </div>
    </div>
  )
}
